import { Button, SxProps, Theme } from "@mui/material";
import { useTranslation } from "react-i18next";
import cloverIcon from "../../assets/img/providers/clover-icon.svg";

const CLOVER_URL_API = process.env.REACT_APP_CLOVER_URL_API ?? "";
const CLOVER_CLIENT_ID = process.env.REACT_APP_CLOVER_CLIENT_ID ?? "";
const REACT_APP_BACKOFFICE_URL = process.env.REACT_APP_BACKOFFICE_URL ?? "";

interface CloverButtonProps {
  onClick?: () => void;
  merchantId?: string;
  sx?: SxProps<Theme>;
}

export function CloverButton({ onClick, merchantId, sx }: CloverButtonProps) {
  const { t } = useTranslation();

  const handleClick = () => {
    const authUrl = `${CLOVER_URL_API}/oauth/v2/authorize?client_id=${CLOVER_CLIENT_ID}&response_type=code&redirect_uri=${REACT_APP_BACKOFFICE_URL}/clover-auth&merchant_id=${merchantId}`;
    window.location.href = authUrl;
    onClick?.();
  };

  return (
    <Button
      title={t("branches.clover.title")}
      onClick={handleClick}
      sx={{
        margin: 0,
        minWidth: "fit-content",
        background: "transparent",
        border: "1px solid #280 !important",
        borderColor: "#280 !important",
        borderRadius: "50%",
        color: "#fff",
        textTransform: "none",
        fontFamily: "Montserrat",
        fontWeight: 300,
        width: "3rem",
        height: "3rem",
        padding: "8px",
        "& img": {
          filter: "none"
        },
        ...sx
      }}
    >
      <img 
        src={cloverIcon}
        alt="Clover icon"
        width={20}
        height={20}
      />
    </Button>
  );
} 